import React from 'react';
import PropTypes from 'prop-types';
import './ImportantInfo.scss';
import ImportantInfoTickbox from './ImportantInfoTickbox';

const ImportantInfo = (props) => {
  const { handleChange, isImportantInfoTickbox } = props;
  return (
    <div className="important-info">
      <div className="heading">Important info about bringing your own modem</div>
      <div className="description">
        <p>Bringing your own modem means we cannot provide you tech support to set it up, and we can&apos;t guarantee it&apos;ll work to the same standard as the modem we&apos;d usually give you.</p>
        <p>If your modem doesn&apos;t work and you wish to leave Skinny you will still need to pay any early termination fees if you had chosen a 12 month contract.</p>
        <p>You&apos;ll need to check a few things to make sure you can use your modem:</p>
        <p><strong>1.</strong> Make sure your modem is compatible. <a href="https://www.skinny.co.nz/help/modem-set-up/byo-modem" rel="noopener noreferrer" target="_blank">Check compatibility</a></p>
        <p><strong>2.</strong> You will need to change your modem&apos;s settings, so you&apos;ll need to be confident about changing these yourself. <a href="https://www.skinny.co.nz/help/modem-set-up/byo-modem" rel="noopener noreferrer" target="_blank">Check the settings you need to know</a></p>
      </div>
      <ImportantInfoTickbox
        id="byomodem-importantinfo"
        name="byomodem-importantinfo"
        label1="I understand and want to use my own modem"
        label2="We will email a link to the modem settings once your order is confirmed."
        checked={isImportantInfoTickbox}
        handleChange={handleChange}
      />
    </div>
  );
};

ImportantInfo.propTypes = {
  isImportantInfoTickbox: PropTypes.bool,
  handleChange: PropTypes.func
};

export default ImportantInfo;



/** WEBPACK FOOTER **
 ** ./src/components/Plans/BringYourOwnModem/ImportantInfo.js
 **/